import React from 'react';

class Cookies extends React.Component {
    render(){
        return (
            <div className="mainContent">
                <div className="textContent leftAlign">
                    <h2>Cookie Notice</h2>
                    <p>This site does not use any cookies which is why there is no cookie banner.</p>

                </div>
            </div>
        )
    }
}

export default Cookies;